<template>
  <div>
    <div class="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div class="sm:mx-auto sm:w-full sm:max-w-sm">
<!--        <img class="mx-auto h-10 w-auto" src="https://tailwindcss.com/plus-assets/img/logos/mark.svg?color=indigo&shade=600" alt="CloudLog" />-->
        <h2 class="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">Восстановление пароля</h2>
      </div>

      <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form v-if="!forgotSend" class="space-y-6" action="#" method="POST" @submit.prevent="submitForm(e)">
          <div>
            <label for="login" class="block text-left text-sm/6 font-medium text-gray-900">Логин</label>
            <div class="mt-2">
              <input type="text" name="login" id="login" autocomplete="email" v-model="formData.login" required="true" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
            </div>
          </div>

<!--          <div>
            <label for="email" class="block text-left text-sm/6 font-medium text-gray-900">Email</label>
            <div class="mt-2">
              <input type="email" name="email" id="email" autocomplete="email" v-model="formData.email" required="" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
            </div>
          </div>-->

          <div>
            <button type="submit" class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Отправить</button>
          </div>
        </form>
        <div v-else>
          Запрос отправлен. Следуйте инструкциии в письме
        </div>

        <p class="mt-10 text-left text-sm/6 text-gray-500">
          <router-link :to="{ name: 'home' }" class="font-semibold text-indigo-600 hover:text-indigo-500">
            ← Форма авторизации
          </router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import store from "@/store";

export default {
  name: 'AuthForgotPage',
  data() {
    return {
      store,
      sending: false,
      errors: null,
      forgotSend: false,
      formData: {
        login: null,
        email: null,
      }
    }
  },
  methods: {
    submitForm: function () {
      this.errors = null;
      if (this.sending) {
        console.log("sending, return")
        return;
      }

      this.$yandexMetrika.reachGoal("forgot")

      console.log("submit")
      let c = this;

      this.sending = true
      this.axios.post('/api/forgot', this.formData).then(function() {
        // console.log(response.data);
        c.forgotSend = true
        c.sending = false
      }).catch(function(err) {
        c.sending = false
        //console.log('ERROR', err);
        if (err.status === 422) {
          c.errors = err.response.data.error;
          return;
        }

        c.errors = "Ошибка";
      });
    }
  }
}
</script>